export default __webpack_public_path__ + "static/media/carousel-image.png.webp";